import React from 'react'
import styled from 'styled-components'
import PropTypes from 'prop-types'
import { graphql } from 'react-apollo'

import ModalHeader from './ModalHeader'
import ModalBody from './ModalBody'

import SmartRateQuery from './queries/SmartRateQuery'

const Container = styled.div`
  max-height: 80vh;
  transform: scale(1);
  overflow: hidden;
  width: 560px;
  background: white;
  border-radius: 5px;
`
// Use scale() to make the header behave as if it is positioned relative to the modal container
// https://developer.mozilla.org/en-US/docs/Web/CSS/position#Values

export const SmartRateModal = ({ businessName, onClose, data = {} }) => {
  const { error, loading = true, loan, networkStatus } = data
  return (
    <Container id="smart_rate_modal">
      <ModalHeader
        onClose={onClose}
        title={`Rating details for ${businessName}`}
      />
      <ModalBody
        error={error}
        loading={loading || networkStatus === 4}
        loan={loan}
      />
    </Container>
  )
}

SmartRateModal.propTypes = {
  businessName:    PropTypes.string.isRequired,
  data: PropTypes.shape({
    error:         PropTypes.object,
    loading:       PropTypes.bool,
    loan:          PropTypes.object,
    networkStatus: PropTypes.number
  }),
  error:           PropTypes.object,
  loading:         PropTypes.bool,
  loan:            PropTypes.object,
  onClose:         PropTypes.func
}

const SmartRatesModalQuery = graphql(SmartRateQuery, {
  skip: OwnProps => !OwnProps.isOpen,
  options: ({ loanId }) => ({
    fetchPolicy: 'cache-and-network',
    variables: {
      loanId
    }
  }),
  notifyOnNetworkStatusChange: true
})(SmartRateModal)

export default SmartRatesModalQuery